module.exports = __webpack_public_path__ + "img/close.0b0e6642.svg";